<template>
  <div v-if="isCustomerUser" class="customer-trim-stats">
    <div class="stats-container">
      <div class="stat-item">
        <span class="stat-value">{{ customer_trim_count }}</span>
        <span class="stat-label">Your Designs</span>
      </div>
      <div class="stat-item" v-if="displayedCount !== customer_trim_count">
        <span class="stat-value">{{ displayedCount }}</span>
        <span class="stat-label">Showing</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'CustomerTrimStats',
  
  computed: {
    ...mapState('trims', ['customer_trim_count', 'trims']),
    ...mapGetters('authentication', ['isCustomerUser']),
    
    displayedCount() {
      return this.trims ? this.trims.length : 0
    }
  }
}
</script>

<style scoped>
.customer-trim-stats {
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-radius: 0.375rem;
  border: 1px solid #e9ecef;
}

.stats-container {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #007bff;
  line-height: 1.2;
}

.stat-label {
  font-size: 0.75rem;
  color: #6c757d;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.025em;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .stats-container {
    gap: 1rem;
  }
  
  .stat-value {
    font-size: 1.25rem;
  }
  
  .stat-label {
    font-size: 0.7rem;
  }
}
</style>